<div class="blogs-news-container">
	<div class="content-wrapper">
		<h1 class="page-title">{{ title }}</h1>
		<div class="content-section">
			<p class="intro-text">Stay updated with the latest blogs, news, and announcements from our team.</p>
			
			<!-- Error Display -->
			<p-messages 
				*ngIf="error()" 
				severity="error" 
				[value]="[{severity: 'error', summary: 'Error', detail: error()}]"
				class="error-messages">
			</p-messages>

			<!-- Loading Spinner -->
			<div *ngIf="isLoading()" class="loading-container">
				<p-progressSpinner></p-progressSpinner>
				<p>Loading blog posts...</p>
			</div>

			<!-- Blog Posts Grid -->
			<div class="blog-posts-grid" *ngIf="(blogPosts$ | async) as blogPosts">
				<div 
					*ngFor="let post of blogPosts; let i = index" 
					class="blog-post-card">
					<p-card>
						<ng-template pTemplate="title">
							<h3 class="post-title">{{ extractTitle(post.post) }}</h3>
							<div class="post-meta" *ngIf="post.createdAt">
								<i class="pi pi-calendar"></i>
								<span class="post-date">{{ formatTimestamp(post.createdAt) }}</span>
							</div>
						</ng-template>

						<div class="post-content">
							<!-- Show truncated preview when collapsed -->
							<div *ngIf="!isExpanded(i)" class="post-preview" [innerHTML]="markdownToHtml(truncateText(extractContent(post.post), 200))"></div>
							
							<!-- Show full content when expanded -->
							<div *ngIf="isExpanded(i)" class="post-full-content" [innerHTML]="markdownToHtml(extractContent(post.post))"></div>
							
							<!-- Show Read More button only when not expanded -->
							<div class="post-actions" *ngIf="extractContent(post.post).length > 200 && !isExpanded(i)">
								<button type="button" class="read-more-btn" (click)="toggleExpanded(i)">
									<span>Read More</span>
									<i class="pi pi-chevron-down"></i>
								</button>
							</div>
							
							<!-- Show Read Less button at the bottom when expanded -->
							<div class="post-actions" *ngIf="extractContent(post.post).length > 200 && isExpanded(i)">
								<button type="button" class="read-more-btn" (click)="toggleExpanded(i)">
									<span>Read Less</span>
									<i class="pi pi-chevron-up"></i>
								</button>
							</div>
						</div>
					</p-card>
				</div>
			</div>

			<!-- Empty State -->
			<div *ngIf="(blogPosts$ | async)?.length === 0" class="empty-state">
				<i class="pi pi-file-o"></i>
				<h3>No blog posts available</h3>
				<p>Check back later for new content!</p>
			</div>
		</div>
	</div>
</div> 